<template>
  <div class="course-package" @click="$emit('native')">
    <!-- <div class="course-package-head">
      <span>{{ course.name }}</span>
      <a-button type="link" @click="$emit('native')">查看全部</a-button>
    </div> -->
    <div class="course-package-body">
      <img src="@/assets/img/course-package.png" class="package-body-image" />
      <div class="body-info">
        <h3 class="course-name">
          <span class="tag" v-if="course.source == 1">区域</span>
          <span style="margin-left: 4px">{{ course.name }}</span>
        </h3>
        <div class="body-info-item flex">
          <span class="body-info-period">学段：{{ course.period }}</span>
        </div>
        <div class="body-info-item">
          <span>已使用：</span>
          <span>{{ course.usedCount }}次</span>
        </div>
        <div class="body-info-item">
          <span>剩余可用：</span>
          <span v-if="!course.isLimitCount">无限制</span>
          <span v-else>{{ course.maxCount - course.usedCount }}次</span>
        </div>
      </div>
      <div v-if="course.courseType == 2" class="body-progress">{{ course.childCourseCount }}节</div>
    </div>
    <div class="course-package-footer action">
      <span :disabled="course.source == 1" class="button" type="link" @click.stop="edit">编辑</span>
      <span :disabled="course.hasConfig || course.source == 1 || course.usedCount > 0" type="link" @click.stop="remove" class="button c-red">删除</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CoursePackage',
  props: {
    course: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    remove() {
      if (this.course.source == 1) {
        return this.$message.error('区域项目禁止删除')
      }

      if (this.course.hasConfig || this.course.usedCount > 0) {
        return this.$message.error('该资源包已被使用，无法删除！')
      }
      this.$emit('remove', this.course)
    },
    edit() {
      if (this.course.source == 1) {
        return this.$message.error('区域项目禁止编辑')
      }

      this.$emit('edit', this.course)
    },
  },
}
</script>
<style lang="less" scoped>
.course-package {
  position: relative;
  cursor: pointer;
  padding: 12px;
  height: 180px;
  padding-bottom: 0;
  width: 380px;
  box-sizing: border-box;
  border: 1px solid transparent;
  box-shadow: 0px 0px 3px 0px rgba(94, 94, 94, 0.34);
  border-radius: 3px;
  margin-bottom: 20px;
  overflow: hidden;
  color: #333;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  .course-package-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #dbdbdb;
  }
  .course-package-body {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 1;
    width: 100%;
    padding-bottom: 6px;

    .package-body-image {
      width: 110px;
      height: 110px;
      flex-shrink: 0;
    }
    .body-info {
      flex: 1;
      margin-left: 10px;
      .body-info-label{
        flex-shrink: 0;
      }
      .body-info-period {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .course-name {
        font-size: 16px;
        font-weight: 500;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 220px;

        .tag {
          border: 1px solid #1890ff;
          border-radius: 5px;
          top: 7px;
          color: #1890ff;
          font-size: 12px;
          padding: 1px 3px;
        }
      }
    }
    .body-progress {
      width: 47px;
      height: 47px;
      border-radius: 50%;
      border: 2px solid #1bc2c3;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #1bc2c3;
      font-weight: 500;
      flex-shrink: 0;
      font-size: 14px;
      position: absolute;
      right: 17px;
      bottom: 46px;
    }
  }
  .course-package-footer {
    width: 100%;
    display: flex;
    align-items: center;
    height: 40px;
    border-top: 1px solid #dbdbdb;
    justify-content: end;
    .button {
      margin: 0 8px;
      display: inline-block;
      padding: 4px 0;
      //   height: 26px;
      //   line-height: 26px;
      width: 55px;
      font-size: 12px;
      cursor: pointer;
      display: inline-block;
      border-radius: 14px;
      border: 1px solid #cccccc;
      text-align: center;
      font-weight: 700;
    }
    .button:nth-of-type(2) {
      color: #ee4646;
      border: 1px solid #f9b593;
      margin: 0;
    }
    .button[disabled='disabled'] {
      color: #999999 !important;
      border-color: #999 !important;
    }
  }
}
.course-package:hover {
  box-shadow: 2px 2px 5px 2px rgba(94, 94, 94, 0.34);
  border-radius: 3px;
  box-sizing: border-box;
}
.flex{
  display: flex;
}
</style>
